var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUddannelseslaege(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D6DFF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 21C22.757 21 25 18.757 25 16C25 13.243 22.757 11 20 11C17.243 11 15 13.243 15 16C15 18.757 17.243 21 20 21ZM20 13C21.654 13 23 14.346 23 16C23 17.654 21.654 19 20 19C18.346 19 17 17.654 17 16C17 14.346 18.346 13 20 13Z",
    fill: "#213E82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26H21V28H19V30H21V32H23V30H25V28H23V26Z",
    fill: "#213E82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22C15.289 22 12 24.467 12 28V32H18V30H14V28C14 25.645 16.467 24 20 24C23.533 24 26 25.645 26 28V32H28V28C28 24.467 24.711 22 20 22Z",
    fill: "#213E82"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUddannelseslaege);
export default __webpack_public_path__ + "static/media/uddannelseslaege.d97bd9b421500d6e7dc44d11643b4242.svg";
export { ForwardRef as ReactComponent };